module.exports = __webpack_public_path__ + "static/media/Tram.9a6fd379.mp3";